<template>
  <div class="container-title-cleed">
    <!-- Brand Selection Step -->
    <div v-if="currentStep === 'brandSelection'">
      <div class="title-size-cleed">
        <TwoTitles :title="i18n['title_step1_brand']" />
      </div>
      <input v-model="searchQuery" type="text" :placeholder="i18n['placeholder']" class="search-input">
      <div class="logo-container">
        <div v-for="logo in filteredLogos" :key="logo.name" class="logo" :class="{ 'selected': logo.selected }" @click="selectLogo(logo)">
          <img :src="logo.image" alt="Logo" class="imageLogoShoes" />
        </div>
      </div>
    </div>

    <!-- Size Selection Step -->
    <div v-if="currentStep === 'sizeSelection'">
      <!-- <Divider :text="value_text['modal_size_reco']['divider']['then']" /> -->
      <TwoTitles class="adjust" :title="i18n['title_step2_brand']" />
      <Size v-if="unit_list !== ''" class="size-cleed" :i18n="value_text['modal_size_reco']['size']" :mode-select="'brand'" :select-brand="select_brand" :unit-list="unit_list" :size-list="size_list" :size-min-max="{}" @update-selected-option="updateSelectedOption" />
      <div v-else class="loader-basic-cleed">
        Je charge...
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import Size from "@/components/modal/partials/Size.vue";
import TwoTitles from "@/components/modal/ui/TwoTitles.vue";
import { customLogger } from "@/utils";

export default {
  name: "BrandSelect",
  components: {
    Size,
    TwoTitles,
  },
  props: {
    i18n: {
      type: Object,
      default: () => ({}),
    },
    brands: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      value_text: store.state.config.i18n[store.state.user.lang],
      logos: this.brands.map(brand => ({ ...brand, selected: false })),
      unit_list: '',
      size_list: {},
      select_brand: '',
      currentStep: 'brandSelection',
      searchQuery: '',
    };
  },
  computed: {
    filteredLogos() {
    let result = this.brands;
    if (this.searchQuery) {
      const searchLowerCase = this.searchQuery.toLowerCase();
      result = this.brands.filter(brand => brand.name.toLowerCase().includes(searchLowerCase));
    }
    return result.map(brand => ({ ...brand, selected: false }));
  }
  },
  mounted() {
    this.updateBrandsSize();
    customLogger("filteredLogos", this.filteredLogos);
  },
  methods: {
    selectLogo(selectedLogo) {
      this.logos = this.logos.map(logo => {
        return {
          ...logo,
          selected: logo.name === selectedLogo.name
        };
      });

      store.state.user.modal_reco_sizeContent.shoes_brand_select = selectedLogo.name;
      this.currentStep = 'sizeSelection';
      this.updateBrandsSize();
},
    updateBrandsSize() {
      this.unit_list = '';
      this.logos.forEach((logo) => {
        if (logo.selected === true) {
          this.select_brand = logo.name;
          store.state.user.modal_reco_sizeContent.shoes_brand_select = logo.name;
          for (const unit in logo.sizes) {
            let unitUpper = unit.toUpperCase();
            this.unit_list = [ unitUpper ]
            this.size_list[unitUpper] = logo.sizes[unit];
          }
        }
      });
    },
    updateSelectedOption(value) {
      this.$emit('update-selected-option', value);
    },
  },
};
</script>

<style scoped>
.logo-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr)); /* creates a grid with flexible columns */
  gap: 10px; /* space between grid items */
  justify-content: start;
  align-items: center;
  padding: 10px 20px; /* padding around the grid */
  overflow: auto;
  max-height: 380px;
  width: 95%; /* Full width to utilize the parent's width */
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0; /* Removes margin */
  margin-left: 10px;
  cursor: pointer;
  width: 90px; /* Adjust to your preference */
  height: 90px;
  border-radius: 10px; /* Less rounded corners */
  border: 1px solid #ccc; /* Border color */
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  transition: transform 0.2s ease-in-out;
}

.search-input {
  display: block;
  width: 90%; /* Adjust to match the image */
  padding: 10px 20px; /* More padding for a larger input */
  margin: 10px auto; /* Increase top and bottom margin */
  border: 1px solid #ccc;
  border-radius: 15px; /* More pronounced rounded corners */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  font-size: 16px; /* Larger font size */
}

.search-input:focus {
  outline: none; 
  border-color: #504848;
  background-color: #FFFFFF; 
}

.logo:hover {
  transform: scale(1.05); /* More subtle hover effect */
}

.logo.selected {
  border-color: #15d;
}

.imageLogoShoes {
  max-width: 80%; /* Logo size should not exceed 80% of its container */
  max-height: 80%; /* Adjust accordingly */
}

@media (max-width: 600px) {
  .logo-container {
    max-width: 370px !important;
    margin: 0 auto !important; /* This centers the container */
    padding: 10px !important;
    gap: 10px !important;
    /* Remove align-items unless you want to center the grid items vertically within their cells */
  }
}

</style>
